import { requestScrollToTop } from '@/app/components/ScrollToTop/ScrollToTop'
import { useCallback } from 'preact/hooks'
import { type URLSearchParamsInit, useLocation, useSearchParams } from 'wouter-preact'

export function useNavigate() {
  const [location, setLocation] = useLocation()

  return useCallback(
    (
      to: string,
      options?: {
        replace?: boolean
        state?: Record<string, unknown>
        transition?: boolean
      },
    ) => {
      requestScrollToTop()

      setLocation(to, {
        ...options,
        state: {
          ...(options?.state as Record<string, unknown>),
          from: location,
        },
      })
    },
    [location, setLocation],
  )
}

export function useNavigateSearchParams() {
  const [location] = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()

  const navigate = useCallback(
    (
      nextInit: URLSearchParamsInit | ((prev: URLSearchParams) => URLSearchParamsInit),
      options?: {
        replace?: boolean
        state?: Record<string, unknown>
      },
    ) => {
      setSearchParams(nextInit, {
        ...options,
        state: {
          ...options?.state,
          ...!options?.replace
            ? {
              from: location,
            }
            : {},
        },
      })
    },
    [location, setSearchParams],
  )

  return [searchParams, navigate] as const
}
